// extracted by mini-css-extract-plugin
module.exports = {"block":"MembersHeader_block__htbNI","container":"MembersHeader_container__qql1p"};